// extracted by mini-css-extract-plugin
export default {"sortIcon":"sortIcon___EU6rI"};